import { useEffect, useState } from "react";
import { API_KEY_LOCATION } from "../constants";
import { tempToColor } from "../utils/helpers";
function LocationInfoDisplay({ tempColor, lat, lng }) {
  const [locationData, setLocationData] = useState({});
  useEffect(
    function () {
      async function fetchData() {
        if (lat === undefined || lng === undefined) return;

        const res = await fetch(
          `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&apiKey=${API_KEY_LOCATION}`
        );
        const data = await res.json();
        setLocationData(data.features[0].properties);
      }
      fetchData();
    },
    [lat, lng]
  );
  const { country, city, county, state, ocean } = locationData;
  return (
    <div
      style={{
        transition: ".5s",
        backgroundColor: `${tempToColor(tempColor)}`,

        width: "100%",
        padding: "20px",
        borderRadius: "20px",
      }}
    >
      {ocean === undefined ? (
        <>
          <h3 style={{ textAlign: "center" }}>Location Information</h3>
          <p>
            {" "}
            <strong> Country: </strong> {country ? country : "Not Available!"}
          </p>
          <p>
            {" "}
            <strong> City: </strong> {city ? city : "Not Available!"}
          </p>
          <p>
            {" "}
            <strong> County: </strong> {county ? county : "Not Available!"}
          </p>
          <p>
            {" "}
            <strong> State: </strong> {state ? state : "Not Available!"}
          </p>
        </>
      ) : (
        <h1>Ocean : {ocean}</h1>
      )}
    </div>
  );
}

export default LocationInfoDisplay;
